__turbopack_context__.v({
  "material-icon": "bxzTvW_material-icon",
});
